import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=1d07259e&scoped=true&lang=pug&"
import script from "./footer.vue?vue&type=script&lang=coffee&"
export * from "./footer.vue?vue&type=script&lang=coffee&"
import style0 from "./footer.vue?vue&type=style&index=0&id=1d07259e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d07259e",
  null
  
)

export default component.exports